export default {
    install(Vue) {
        Vue.prototype.$CURRENCY = process.env.VUE_APP_CURRENCY;
        Vue.prototype.$TENANT = process.env.VUE_APP_TENANT;
    }
};
